import { useState, useEffect } from 'react';
import { Card, Typography, Row, Col, Tag, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { EditOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

export default function FormTemplatesList() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const res = await fetch('/api/v1/form-builder/forms?isTemplate=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await res.json();
      setTemplates(data);
    } catch (error) {
      console.error('Failed to fetch templates');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: 24, textAlign: 'center' }}>Loading templates...</div>;
  }

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Form Templates</Title>
      
      <Paragraph>
        Browse and customize pre-built form templates to quickly create feedback forms.
      </Paragraph>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        {templates.map((template) => (
          <Col xs={24} sm={12} md={8} key={template.id}>
            <Card
              title={template.name}
              extra={<Tag color="purple">{template.layout.columns}-Column</Tag>}
            >
              <Paragraph>{template.description}</Paragraph>
              <Tag>{template.layout.fields?.length || 0} fields</Tag>
              <div style={{ marginTop: 16 }}>
                <Space>
                  <Button
                    type="primary"
                    onClick={() => navigate(`/feedback/forms/new?templateId=${template.id}`)}
                  >
                    Use Template
                  </Button>
                  <Button
                    icon={<EditOutlined />}
                    onClick={() => navigate(`/feedback/form-templates/${template.id}/edit`)}
                  >
                    Edit Template
                  </Button>
                </Space>
              </div>
            </Card>
          </Col>
        ))}

        {templates.length === 0 && (
          <Col span={24}>
            <Card>
              <div style={{ textAlign: 'center', padding: 40 }}>
                <Text type="secondary">No templates available. Create a form and save it as a template!</Text>
              </div>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
}
